module.exports = __webpack_public_path__ + "img/yw5.e7d43fd7.png";